import { getLocaleCodeByCountryCode } from '@zep-us/i18n';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { useCountryCode } from '@/shared/hooks';

const DEFAULT_INQUIRY_URL = 'https://tally.so/r/wvLX7X';

interface UseInquiryUrlOptions {
  /** KR일 때 사용할 내부 URL (예: '/pricing', '/embed/sales?type=inquiry') */
  krUrl?: string;
  /** 외부에서 countryCode를 주입 (제공하지 않으면 useCountryCode에서 가져옴) */
  countryCode?: string;
}

/**
 * 국가 코드에 따라 적절한 문의 URL을 여는 훅
 * - KR + krUrl 제공: 내부 라우팅 (router.push)
 * - 그 외: locale별 번역 리소스에서 URL을 가져와 새 탭으로 열기
 */
export function useInquiryUrl({
  krUrl = '/pricing',
  countryCode: externalCountryCode,
}: UseInquiryUrlOptions) {
  const router = useRouter();
  const { countryCode: userCountryCode, isKR: userIsKR } = useCountryCode();
  const { i18n } = useTranslation(['common']);

  const countryCode = externalCountryCode ?? userCountryCode;
  const isKR = externalCountryCode ? externalCountryCode === 'KR' : userIsKR;

  const openInquiryUrl = async () => {
    if (isKR) {
      void router.push(krUrl);
      return;
    }

    try {
      const locale = getLocaleCodeByCountryCode(countryCode);
      await i18n.reloadResources(locale, 'common');
      const inquiryUrl = i18n.t('common:paypal.help');

      if (!inquiryUrl) {
        window.open(DEFAULT_INQUIRY_URL, '_blank', 'noopener,noreferrer');
        return;
      }

      window.open(inquiryUrl, '_blank', 'noopener,noreferrer');
    } catch {
      window.open(DEFAULT_INQUIRY_URL, '_blank', 'noopener,noreferrer');
    }
  };

  return { openInquiryUrl };
}
